const axios = require('axios');

import {
	serverUrl,
	presighnedUrl
} from '../properties'
const dataUrl = serverUrl;

export default {
	namespaced: true,
	state:{

	},
	mutations:{

	},
	getters:{

	},
	actions:{
		saveData: ({ commit, state, rootGetters, rootState }, payload) => {
			return new Promise((resolve, reject) => {

				payload.userName = JSON.parse(window.localStorage.session).name;


				axios({
					url: dataUrl + '/map/vendor',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					if (response.data) {
						resolve(response.data)
					}
				}).catch((error) => {
					console.log(error)
					commit('hideLoadingSpinner', null, { root: true })
				})
			})
	   },

   }
}
